import { GetStaticProps } from 'next';
import { NextSeo } from 'next-seo';

import { Analytics } from '$components/analytics';
import { GetInfoAndLatestProjectsDocument } from '$graphql/generated';
import { findPosts } from '$http/find-posts';
import { request } from '$services/dato';
import { HomeTemplate } from '$templates/home-template';
import { Project } from '$templates/home-template/projects';
import { WritingPost } from '$templates/home-template/writing';
import { formatProject } from '$utils/format-project';

interface HomeProps {
  projects: Project[];
  posts: WritingPost[];
  techs: string[];
  about: string;
}

export default function Home({ projects, posts, techs, about }: HomeProps) {
  return (
    <>
      <NextSeo
        title="Silvano Marques — Desenvolvedor Full‑Stack"
        description="Silvano Marques, desenvolvedor full‑stack. Projetos pessoais, escrita e contato."
        openGraph={{
          images: [
            {
              url: 'https://silvanomarques.vercel.app/cover.png',
              width: 1280,
              height: 720,
              alt: 'Silvano Marques',
            },
          ],
        }}
      />

      <Analytics />

      <HomeTemplate
        projects={projects}
        posts={posts}
        techs={techs}
        about={about}
      />
    </>
  );
}

export const getStaticProps: GetStaticProps<HomeProps> = async () => {
  const data = await request(GetInfoAndLatestProjectsDocument, { first: 4 });

  const projects = data.allProjects.map(formatProject);
  const techs = (data.info?.techs as string[] | undefined) ?? [];
  const about = (data.info?.aboutMe as string | undefined) ?? '';

  let posts: WritingPost[] = [];
  try {
    const rawPosts = await findPosts({ page: 1, size: 3 });
    posts = rawPosts.map((post) => ({
      slug: post.slug,
      title: post.title,
      description: post.description,
      createdAt: post.createdAt,
      readingMinutes: post.readingMinutes,
    }));
  } catch {
    posts = [];
  }

  return {
    revalidate: 60 * 60 * 24 * 7,
    props: { projects, posts, techs, about },
  };
};
